import React from "react";

export const CustomInputArea = (props) => {

    const { type, label, placeholder, error, onChange, value, disabled, rows, defaultValue } = props;

    return (
        <div style={{ display: 'flex', flexFlow: 'column noWrap', gap: 5, marginBottom: 15 }}>
            <label style={{ fontWeight: 600, fontSize: 14 }} htmlFor={ label }>{ label }</label>
            <textarea rows={ rows } cols={1} style={
                error ? { borderRadius: 4, border: '1px solid #d32f2f', padding: 10, resize: 'none' }
                      : { borderRadius: 4, border: '1px solid #bdbdbd', padding: 10, resize: 'none' }
            } id={ label } type={ type } placeholder={ placeholder } onChange={ onChange } value={ value } defaultValue={ defaultValue } disabled={ disabled } />
            <span 
                style={
                    error ? { fontSize: 12, color: '#d32f2f', marginLeft: 5 }
                          : { fontSize: 12, color: 'rgba(0,0,0,.6)', marginLeft: 5 }
                }>{ error && error?.message }</span>
        </div>
    )
};

CustomInputArea.defaultProps = {
    type: 'text',
    label: 'Label',
    placeholder: 'abc',
    error: null,
    onChange: () => false,
    value: '',
    disabled: false,
    rows: 4
}